import styled from 'styled-components';
import { ButtonToolbar } from 'rsuite';

export default styled(ButtonToolbar)`
  margin-bottom: 20px;
  padding-bottom: 10px;
`;
